import { useEffect } from 'react';
import { afbRecurringFrecuency, afbRecurringType } from '../../../util/DataObject';
import { useOperationManager } from './hooks/useOperationManager';
import { Dialog, DialogContent, DialogTitle, DialogActions, FlexGrid, Typography, Button } from "@albo-ui/core";
import { MenuItem, Select, FormControl, InputLabel, IconButton, List, ListItem, ListItemText, Alert, Box, TextField, Divider, InputAdornment } from "@mui/material";
import { SearchOutlined, GroupAdd, Close } from "@mui/icons-material";
import { AfbOperationManagerProps } from "./types";
import { styled } from '@mui/material/styles';
import GeneralConfirmDialog from "../../modals/confirm/GeneralConfirmDialog";


const FireNav = styled(List)({
    '& .MuiListItem-root': {
        padding: 0,
    },
    '& .MuiSvgIcon-root': {
        fontSize: 20,
        marginRight: 16,
    },
});

const AfbOperationManager = ({ data, open, onClose, changeAlert, changeLoader, onHandleExecute }: AfbOperationManagerProps) => {
    const { zPos, form, error, loading: loadingRequest, spaces, searchForm, email, isValid, catalogBank, item, element, dialogText, dialogProps, setForm, onSearch, onHandleSearch, onHandleChange, setEmail, onHandleDelete, formatDateForInput, onHandleConfirm, onCloseDialogConfirm, onOpenConfirm } = useOperationManager(open, onClose, changeAlert, onHandleExecute, data);
    
    useEffect(() => {
        changeLoader(loadingRequest);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingRequest]);

    useEffect(() => {
        data && setForm(JSON.parse(JSON.stringify(data)));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);


    return (
        <>
        <Dialog onClose={() => ""} open={open} style={{ display: zPos !== 45 ? "none" : null, minWidth: "700px", maxHeight: "600px" }}>
            <DialogTitle>
                <Typography variant='h2'>{data ? "Actualizar" : "Crear"} Operación Recurrente</Typography>
            </DialogTitle>

            <DialogContent>
                { form && form["source_customer_uuid"] && <Divider sx={{mt: 2, "&::before, &::after": {borderColor:  "primary.light", width: "100%" }}} >Origen</Divider>}
                { form && form["metadata"] && form["metadata"]["customer_name"] && <TextField value={form["metadata"]["customer_name"]} disabled label={"Empresa"} size='small' color='primary' variant='outlined' sx={{mt: 2}} fullWidth />}
                {!data && 
                    <Box>
                    {!form && <Alert severity={"info"}>
                        Completa el campo con el UUID del Cliente Origen.
                    </Alert>}

                    <TextField value={(searchForm && searchForm["customer_uuid"]) || ""} onChange={onHandleSearch.bind(this)} label={"UUID Cliente"} size='small' color='primary' variant='outlined' sx={{my: 2}} fullWidth InputLabelProps={{ shrink: true }}
                        InputProps={{ endAdornment: <IconButton onClick={onSearch}><SearchOutlined /></IconButton> }}
                    />
                    </Box>
                }
                { !data && spaces && spaces.length > 0 && 
                    <FlexGrid>
                        <FormControl variant="outlined" fullWidth >
                            <InputLabel>Espacio</InputLabel>
                            <Select label={"Espacio"} value={(form && form["source_space_uuid"]) || -1} onChange={onHandleChange.bind(this, "source_space_uuid", null)} color="secondary" MenuProps={{style: {zIndex: 35001}}} sx={{mb: 1}} fullWidth variant="outlined">
                                <MenuItem value={-1} disabled>Seleccione</MenuItem>
                                {spaces.map((i) => (
                                    <MenuItem key={`space-${i.uuid}`} value={i.uuid}>
                                        {i.uuid}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </FlexGrid>
                }
                { form && form["source_space_uuid"] && <FlexGrid container spacing={2} style={{display: "block", marginTop: 20}}>
                        <Divider sx={{mb: 2, "&::before, &::after": {borderColor:  "primary.light", width: "100%" }}} >Configuración</Divider>
                        
                        <FlexGrid item container spacing={2} fullWidth style={{marginBottom: 16}}>
                            <TextField label="Fecha y hora de inicio" value={(form && formatDateForInput(form["start_date"])) || ""} onChange={onHandleChange.bind(this, "start_date", null)} disabled={data ? true : false} type={"datetime-local"} InputLabelProps={{ shrink: true }} size="small" fullWidth />
                            <TextField label="Fecha y hora de fin" value={(form && formatDateForInput(form["end_date"])) || ""} onChange={onHandleChange.bind(this, "end_date", null)} type={"datetime-local"} InputLabelProps={{ shrink: true }} size="small" fullWidth />
                        </FlexGrid>

                        <FlexGrid item container spacing={2} fullWidth>
                            <FormControl variant="outlined" fullWidth>
                                <InputLabel>Frecuencia</InputLabel>
                                <Select label={"Frecuencia"} value={(form && form["frecuency"]) || -1} onChange={onHandleChange.bind(this, "frecuency", null)} disabled={data ? true : false} color="secondary" MenuProps={{style: {zIndex: 35001}}} sx={{mb: 2}} fullWidth variant="outlined">
                                    <MenuItem value={-1} disabled>Seleccione</MenuItem>
                                    {afbRecurringFrecuency.map((i) => (
                                        <MenuItem key={`frequency-${i.key}`} value={i.key}>
                                            {i.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl variant="outlined" fullWidth >
                                <InputLabel>Tipo</InputLabel>
                                <Select label={"Tipo"} value={(form && form["amount_config"] && form["amount_config"]["type"]) || -1} onChange={onHandleChange.bind(this, "amount_config", "type")} disabled={data ? true : false} color="secondary" MenuProps={{style: {zIndex: 35001}}} sx={{mb: 2}} fullWidth variant="outlined">
                                    <MenuItem value={-1} disabled>Seleccione</MenuItem>
                                    {afbRecurringType.map((i) => (
                                        <MenuItem key={`type-${i.key}`} value={i.key}>
                                            {i.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </FlexGrid>
                        { form["amount_config"] && (form["amount_config"]["type"] === "FIXED" || form["amount_config"]["type"] === "PERCENTAGE") && <FlexGrid item container spacing={2} fullWidth style={{marginBottom: 16}}>
                            <TextField value={(form && form["amount_config"] && form["amount_config"]["value"]) || ""} onChange={onHandleChange.bind(this, "amount_config", "value")} disabled={data ? true : false} label={"Valor"} color='primary' variant='outlined' style={{width: "49%"}} />
                        </FlexGrid> }

                        <Divider sx={{mt: 3, mb: 2, "&::before, &::after": {borderColor:  "primary.light" }}}>Destino</Divider>
                        <FlexGrid item container spacing={2} fullWidth style={{marginBottom: 16}}>
                            <TextField value={(form && form["target_receipt"] && form["target_receipt"]["name"]) || ""} onChange={onHandleChange.bind(this, "target_receipt", "name")} disabled={data ? true : false} label={"Nombre"} color='primary' variant='outlined' fullWidth />
                            <TextField value={(form && form["target_receipt"] && form["target_receipt"]["clabe"]) || ""} onChange={onHandleChange.bind(this, "target_receipt", "clabe")} disabled={data ? true : false} label={"CLABE"} color='primary' variant='outlined' fullWidth />
                        </FlexGrid>

                        <FlexGrid item container spacing={2} fullWidth style={{marginBottom: 16}}>
                            {catalogBank && <FormControl variant="outlined" fullWidth >
                                <InputLabel>Banco</InputLabel>
                                <Select label={"Banco"} value={(form && form["target_receipt"] && form["target_receipt"]["bank_id"]) || -1} onChange={onHandleChange.bind(this, "target_receipt", "bank_id")} disabled={data ? true : false} color="secondary" MenuProps={{style: {zIndex: 35001}}} sx={{mb: 2}} fullWidth variant="outlined">
                                    <MenuItem value={-1} disabled>Seleccione</MenuItem>
                                    {catalogBank?.map((item, i ) => (
                                        <MenuItem key={`type-${item.k}-${i}`} value={item.k}>
                                            {item.v}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>}
                            <TextField
                                label="Correo de notificación" 
                                onChange={(e) => setEmail(e.target.value)} fullWidth
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">
                                    <IconButton
                                        title={`Agregar \ncorreo`}
                                        onClick={() => onHandleChange("notification_emails", null, email)}
                                        edge="end"
                                    >                
                                    <GroupAdd/>
                                    </IconButton>                
                                    </InputAdornment>,
                                }} />
                        </FlexGrid>

                        {form["notification_emails"]?.length > 0 && 
                            <FlexGrid item>
                                <hr style={{margin: "6px 0 14px 0"}}/>
                                <p style={{padding: "0px"}}>Correos a notificar:</p>
                                <FireNav disablePadding>
                                    <List >
                                    {form["notification_emails"]?.map((i) => {
                                        return <ListItem style={{fontStyle: "oblique", color: "#969BA0"}} key={i}><Close titleAccess={`Eliminar \ncorreo`} onClick={() => onHandleDelete(i)} cursor={"pointer"}/><ListItemText primary={i} /></ListItem>
                                    })}
                                    </List>
                                </FireNav>
                            </FlexGrid>
                        }
                    </FlexGrid>
                }

                {error && <Typography variant="smallTitle" color="sunset">{error}</Typography>}
            </DialogContent>

            <DialogActions>
                <FlexGrid container fullHeight fullWidth justify="space-between" alignItems="flex-end" style={{ marginTop: 10 }} spacing={2}>
                    <FlexGrid item>
                        <Button onClick={onClose} buttonType="secondary" size="normal">Cancelar</Button>
                    </FlexGrid>
                    <FlexGrid item>
                        <Button onClick={onOpenConfirm.bind(this)} disabled={isValid} size="normal">Aceptar</Button>
                    </FlexGrid>
                </FlexGrid>
            </DialogActions>
        </Dialog>
        <GeneralConfirmDialog 
            open={dialogProps.open}
            text={dialogText}
            onClose={onCloseDialogConfirm} 
            onConfirm={onHandleConfirm.bind(this)} 
            item={item}
            element={element}
        />
        </>
    );
};

export default AfbOperationManager;
